module.exports = function(app) {
	'use strict';
	app.directive('eprSaveFooter', function() {

		return {
			restrict: 'A',
			replace: false,
			template: require('directives/employee/eprSaveFooter.html'),

			scope: {
				formName: '=eprSaveFooter',
				beforeSubmit: '&?',
				afterSubmit: '&?'
			},

			controller: ['$rootScope', '$scope', '$state', '$location', '$window', '$q', '$timeout', 'employee', 'addFlowCommander', 'modal',
				'services', 'coremetrics','storage', 'sessionData',
				function($rootScope, $scope, $state, $location, $window, $q, $timeout, employee, addFlowCommander, modal, services, coremetrics,storage, sessionData) {


					var preSubmitHook = $scope.beforeSubmit
										? function() { return $q.when($scope.beforeSubmit()); }
										: $q.when;

					var postSubmitHook = $scope.afterSubmit
										? function(response, isForLater) { $scope.afterSubmit({ response: response, isForLater: isForLater }); }
										: function() { console.debug('no postSubmit hook to call'); };

					$scope.aemMode = false;
					if(window.location.href.indexOf('https://aem') != -1){
						$scope.aemMode = true;
					}

					var isValid = function(form) {
						form.$setSubmitted();
						return form.$valid;
					};
                    var sentenceCase = function(theString) {
                    	var responseFormat = [];
                        var newString = function(thS){
                            return thS.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g,function(c){return c.toUpperCase()});
						}
						Object.keys(theString).forEach(function (cove) {
                            responseFormat.push(newString(theString[cove]));
                        });
                        return responseFormat;
					};

					var handleFailedSave = function(error) {
						if (addFlowCommander.isInAddFlow()) { addFlowCommander.denyCurrentStep(); }

						var template = require('pages/employee/modals/transactionError.html');
						var onClose = function() { $state.go('home'); };;
						if (error && error.message) {
							switch(error.message) {
								case 'pendingTransaction':
									template = require('pages/employee/modals/pendingTransaction.html');
									break;
								case 'visionDental' :
                                    template = require('pages/employee/modals/visionAndDentalModal.html');
                                    onClose = function() {  };
									break;
								default:
									template = '<article>'+
										'<h1 class="modal-title">Warning</h1>'+
										'<p>'+error.message+'</p>'+
										'<button type="button" class="secondary-button-1" data-ng-click="closeModal()">OK</button>'+
									'</article>';
									onClose = function() {  };
							}
						}

						modal.open({
							template: template,
							classes: "epr-standard-modal",
							onClose: onClose
						});
					};


					$scope.isInAddFlow = addFlowCommander.isInAddFlow();

					var addFlowIntermediateSave = function(isForLater) {
						/*if($scope.aemMode){
							if (!isForLater) {
								addFlowCommander.approveCurrentStep();
								addFlowCommander.advance(employee.data.subscriber.umi || employee.data.subscriber.ssn);
							}
						}
						else{*/
							return employee.save(employee).then(
								function(response) {
									if (response && response.status == 200) {
                                        if((sessionData.employerInfo.brandName === '6012'|| sessionData.employerInfo.brandName === '9017' ||sessionData.employerInfo.brandName === '9018') && response.data && response.data.payload){
											if(window.location.href.indexOf('add/coverage')!= -1 && response.data.payload.validateProductsResponse && Object.keys(response.data.payload.validateProductsResponse).length > 0){
                                        	$scope.validateProductsResponse = response.data.payload.validateProductsResponse;
                                           // var error = {message : 'visionDental' };
                                            employee.succeeded = true;
                                                var visModalScope = $rootScope.$new();
                                                visModalScope.validateProductsResponse = sentenceCase($scope.validateProductsResponse);

                                                modal.open({
                                                               template: require('pages/employee/modals/visionAndDentalModal.html'),
                                                               scope: visModalScope,
                                                               classes: 'epr-standard-modal'

                                                           });
                                            //handleFailedSave(error);
										}
										else{
                                            if (!isForLater) {
                                                addFlowCommander.approveCurrentStep();
                                                addFlowCommander.advance(employee.data.subscriber.umi || employee.data.subscriber.ssn);
                                            }

										}
                                        }
										else if (!isForLater && sessionData.employerInfo.brandName !== '6012' &&sessionData.employerInfo.brandName !== '9017' && sessionData.employerInfo.brandName !== '9018') {
											addFlowCommander.approveCurrentStep();
											addFlowCommander.advance(employee.data.subscriber.umi || employee.data.subscriber.ssn);
										}
									}
									else { handleFailedSave(); }
								},
								handleFailedSave
							);
						//}
					};

					var addFlowFinalStepSave = function(isForLater) {
						var isFinal = !isForLater;
							return employee.save(employee, isFinal).then(
								function (response) {
									return postSubmitHook(response, isForLater);
								},
								handleFailedSave
							);
					};

					var editExistingEmployee = function() {
						var ssn = employee.editInProgress.data.subscriber.ssn;
						var payload = { data: angular.copy(employee.editInProgress.data) };
						var checkIfInProcess = services.eprsvc.enrollments().check(ssn);
                        var checkForProductInArray = function(groupNum, lob, arrayName) {
                            var isMarked = false;
                            if (employee.editInProgress.coverages && Array.isArray(employee.editInProgress.coverages[arrayName])) {
                                employee.editInProgress.coverages[arrayName].forEach(function(obj) {
                                    if (groupNum === obj.groupNumber && lob.lineOfBusiness === obj.lineOfBusiness) {
                                        isMarked = true;
                                    }
                                });
                            }
                            return isMarked;
                        };
						//not sending inactive spouses
						var removeMembersWithNoActiveCoverages = function(payload){
							for(var i=0; i<payload.data.dependents.length; i++){
								if(payload.data.dependents[i].relationshipCode === '01' || payload.data.dependents[i].relationshipCode === '29'){
                                    var anyActiveLobs = false;
                                    var today = new Date();
                                    if (Array.isArray(payload.data.dependents[i].memberCoverages)) {
                                        payload.data.dependents[i].memberCoverages.forEach(function(coverage) {
                                            if (Array.isArray(coverage.memberLobs)) {
                                                coverage.memberLobs.forEach(function(lob) {
                                                    if(checkForProductInArray(coverage.groupNumber, lob, "forDeletion")){
                                                        anyActiveLobs = true;
                                                    }
                                                    if (!lob.coverageEndDate || lob.coverageEndDate > today) {
                                                        anyActiveLobs = true;
                                                    }
                                                });
                                            }
                                        });
                                    }
                                    if(!anyActiveLobs){
                                        payload.data.dependents[i] = null;
									}
								}
							}
							for(var i=0; i< payload.data.dependents.length; i++){
								if(payload.data.dependents[i] === null){
                                    payload.data.dependents.splice(i, 1);
                                    i -= 1;
                                }
							}
						};

						var backupEditedEmployee = function(inProcess) {
							//window.location.href.indexOf('add/coverage')!= -1 &&
                            if (!inProcess) {
                                return employee.save(payload, false, true).then(
                                    function(response) {
                                        if (response && response.status == 200) {
                                            if((sessionData.employerInfo.brandName === '6012' ||sessionData.employerInfo.brandName === '9018' ||sessionData.employerInfo.brandName === '9017') && response.data && response.data.payload){
                                                if(response.data.payload.validateProductsResponse && Object.keys(response.data.payload.validateProductsResponse).length > 0){
                                                    $scope.validateProductsResponse = response.data.payload.validateProductsResponse;
                                                    //employee.succeeded = true;
                                                    $state.go('employee.find.addCoverage');
                                                    var visModalScopeEdit = $rootScope.$new();
                                                    visModalScopeEdit.validateProductsResponse = sentenceCase($scope.validateProductsResponse);
                                                    //visModalScopeEdit.sentCase = sentenceCase();

                                                   modal.open({
                                                                   template: require('pages/employee/modals/visionAndDentalModal.html'),
                                                                   scope: visModalScopeEdit,
                                                                   classes: 'epr-standard-modal'

                                                               });
                                                    return $q.reject();
                                                }
                                                else{
                                                    return response;

                                                }
                                            }
                                            else {
                                                return response;
											}

                                        }
                                    },
                                    handleFailedSave
                                );
                            }
							else {
								return $q.reject(new Error('pendingTransaction'));
							}
						};
						var saveEditedEmployee = function() {
							return employee.save(payload, true, true).then(
								function(response) {
									employee.editInProgress.reset();
									employee.metadata = {};
									launchEditResponseModal(response, payload.data);
								},
								handleFailedSave
							);
						};

                        removeMembersWithNoActiveCoverages(payload);
						return checkIfInProcess
							.then(backupEditedEmployee)
							.then(saveEditedEmployee)
							.catch(handleFailedSave);
					};

					var hasAlreadyRun = false;
					var save = function(isForLater) {
						if (!isValid($scope.formName)) {
							window.frForm = $scope.formName;
							$scope.canLeave = false;
							return;
						}
						//if ($state.current.name == 'employee.add.subscriber' && !isForLater) {
						//	coremetrics.elementTag('SUBSCRIBER AND DEPENDENT SAVE & CONTINUE', 'EMPLOYERS:ENROLLMENT');
						//}
						//if ($state.current.name == 'employee.add.subscriber' && isForLater) {
						//	coremetrics.elementTag('SUBSCRIBER AND DEPENDENTS SAVE FOR LATER', 'EMPLOYERS:ENROLLMENT');
						//}
                       $scope.canLeave = true;
                            employee.isLoading = true;



						return preSubmitHook().then(
							function() {
								if (!hasAlreadyRun) {
									hasAlreadyRun = true;
									employee.metadata = {};

									switch ($state.current.name) {
										case 'employee.add.reviewSubmit':
											return addFlowFinalStepSave(isForLater);
										case 'employee.find.review':
											var t = editExistingEmployee();
											t.finally(function() {
												hasAlreadyRun = false;
											});
											return t;
										default:
											return addFlowIntermediateSave(isForLater);
									}
								}
							},
							function(errorOrFallback) {
								if (errorOrFallback instanceof Function) {
									return errorOrFallback();
								}
								console.debug('the beforeSave hook was rejected with:', errorOrFallback);
							}
						).finally(function() {
							employee.isLoading = false;
						});
					};



					$scope.proceed = function() {
						if($state.current.name == 'employee.find.review'){
							coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:EDIT EMPLOYEE','EMPLOYERS ENROLLMENT');
						}
						if($state.current.name == 'employee.add.subscriber'){
							if(storage.get('AddDependent') == "1"){
								coremetrics.finishConversion("EMPLOYERS:ENROLLMENT:ADD DEPENDENT","EMPLOYERS:ENROLLMENT");
							}
							coremetrics.elementTag('SUBSCRIBER AND DEPENDENT SAVE & CONTINUE','EMPLOYERS:ENROLLMENT:ADD EMPLOYEE SUBSCRIBERS AND DEPENDENT');
						}
						if($state.current.name == 'employee.add.coverage'){
							coremetrics.elementTag('SUBSCRIBER AND DEPENDENT SAVE & CONTINUE','EMPLOYERS:ENROLLMENT:ADD EMPLOYEE:PLAN COVERAGE');
						}
						if($state.current.name == 'employee.add.reviewSubmit'){

							coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:ADD EMPLOYEE:REVIEW AND SUBMIT','EMPLOYERS:ENROLLMENT');
						}
						save();
					};

					$scope.saveForLater = function(callback) {

						console.log("coremetrics:",$state.current.name);
							if($state.current.name == 'employee.add.subscriber'){
								coremetrics.elementTag('SUBSCRIBER AND DEPENDENT SAVE FOR LATER','EMPLOYERS:ENROLLMENT:ADD EMPLOYEE SUBSCRIBERS AND DEPENDENT');
							}
							else if($state.current.name == 'employee.add.coverage'){
								coremetrics.elementTag('SUBSCRIBER AND DEPENDENT SAVE FOR LATER','EMPLOYERS:ENROLLMENT:ADD EMPLOYEE:PLAN COVERAGE');
							}
							else if($state.current.name == 'employee.add.reviewSubmit'){
								coremetrics.elementTag('SUBSCRIBER AND DEPENDENTS SAVE FOR LATER','EMPLOYERS:ENROLLMENT:ADD EMPLOYEE:REVIEW AND SUBMIT');
						    }
						callback = callback || function() { $state.go('home'); };
						save(true).then(
							function() { $scope.canLeave = true; callback(); },
							handleFailedSave
						);
					};

					$scope.cancel = launchUnsavedChangesModal;

					$scope.saveButtonText = $state.current.name === 'employee.add.reviewSubmit'
											? 'Finish'
											: 'Save & Continue';


					(function setupBrowseaway() { // TODO: abstract this at some point - handle sentinels in a centralized manner
						if (addFlowCommander.isInAddFlow() || $state.current.name === 'employee.find.review') {
							$scope.canLeave = false;

							var disallowNonAddDestination = function(next) {
								return next
									? next.name.indexOf('employee.add') < 0
									: $location.path().indexOf('manage-employees/add') < 0;
							};

							var disallowNonEditDestination = function(next) {
								var shouldBlockURL = function() {
									var destinationURL = $location.path();

									var whitelist =  [
										'find/add-coverage',
										'find-a-doctor',
										'RedirectWeb/RedirectServlet'
									];

									return whitelist.every(
										function(slug) {
											return destinationURL.indexOf(slug) < 0;
										}
									);
								};

								return next
									? next.name.indexOf('employee.find.addCoverage') < 0
									: shouldBlockURL();
							};

							var guard = addFlowCommander.isInAddFlow()
									? disallowNonAddDestination
									: disallowNonEditDestination;

							$scope.$on('$locationChangeStart', function(event, next) {
								if (!$scope.canLeave && guard(null)) {
									event.preventDefault();
									$scope.changeOfLocation = true;

									launchUnsavedChangesModal(function() {
										$window.location = next;
									});
								}
							});
							$scope.$on('$stateChangeStart', function(event, next) {
								if (!$scope.changeOfLocation && !$scope.canLeave && guard(next)) {
									event.preventDefault();

									launchUnsavedChangesModal(function() {
										$state.go(next.name);
									});
								}
							});
						}
					}());

					function launchUnsavedChangesModal(callback) {
						var modalScope = $rootScope.$new();

						var ensureClose = function(operation) {
							return function(close) {
								if(storage.get('AddDependent') == "1"){
									storage.set('AddDependent',"0");
								}
								$timeout(operation, 100);
								if (close instanceof Function) {
									close();
								}
							};
						};

						if (addFlowCommander.isInAddFlow()) {
							var modalSave = $state.current.name === 'employee.add.reviewSubmit'
											? function() { $scope.canLeave = true; $state.go('home'); }
											: function() { return $scope.saveForLater(callback); };

							modalScope.save = ensureClose(modalSave);
						}
						else if ($state.current.name === 'employee.find.review') {
							modalScope.returnToSave = modal.close;
						}

						var abandonChanges = function() {
							var fn = callback || function() { $state.go('home'); };
							employee.metadata = {};
							$scope.canLeave = true;
							fn();
						};

						modalScope.abandonChanges = ensureClose(abandonChanges);

						var numberAndName = employee.data.subscriber.ssn;
						if (!numberAndName) {
							return modalScope.abandonChanges();
						}

						if (employee.data.subscriber.fullName.last) {
							numberAndName += ': ' + employee.data.subscriber.fullName.last;
							if (employee.data.subscriber.fullName.first) {
								numberAndName += ', ' + employee.data.subscriber.fullName.first;
							}
						}

						modalScope.numberAndName = numberAndName;

						modal.open({
							scope: modalScope,
							templateUrl:'_modals/unsaved.employerTemplate.html/pages/employee/modals/unsavedChanges',
							classes: "epr-standard-modal large-modal"
						});
					}


					function launchEditResponseModal(response, employeeData) {
						if (response && response.data && response.data.payload instanceof Object) {
							var payload = response.data.payload;
							var groupNumbers = Object.keys(payload);

							var allSucceeded = groupNumbers.every(function(g) { return payload[g]; });
							var allFailed = groupNumbers.every(function(g) { return !payload[g]; });

							// var onClose = function() {
							// 	$timeout(function() {
							// 		if ($state.current && $state.current.name === 'employee.find.review') {
							// 			$state.go('home');
							// 		}
							// 	}, 10);
							// };

							var name = employee.getDisplayName(employeeData.subscriber);

							var modalScope = $rootScope.$new();
							modalScope.goHome = function() { $state.go('home'); };

							if (allSucceeded) {
								coremetrics.finishConversion('EMPLOYERS:ENROLLMENT:EDIT EMPLOYEE','EMPLOYERS:ENROLLMENT');
								coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:EDIT EMPLOYEE','EMPLOYERS:ENROLLMENT');
								modalScope.modalHeading = 'Success';
								modalScope.modalBody = 'You have successfully edited ' + name;
							}
							else if (allFailed) {
								modalScope.modalHeading = 'Submitted';
								modalScope.modalBody =
									'Your transaction could not be fully processed at this time for ' +
									name + '. Please allow 48 hours for us to complete your transaction';
							}
							else {
								modalScope.modalHeading = 'Partially Submitted';
								modalScope.modalBody =
									'Your transaction could not be fully processed at this time for ' +
									name + '. Please allow 48 hours for us to complete your transaction';
							}

							modal.open({
								scope: modalScope,
								template: require('pages/employee/modals/statusOfSave.html'),
								classes: "epr-standard-modal large-modal"
							});
						}
					}
				}
			]
		};
	});
};
